import log from '$$log';
import TodayMarker from '../../chart/todayMarker';
import Config from '../../config';
import Columns from '../../grid/columns';
import Zoom from '../../chart/zoom';
import Baselines from '../../baselines';
import ColumnsBar from '../../../columnsConfigBar/columnsBar';
import ColumnsConfig from '../../grid/columns/columnsConfig';

export default instance => {
  instance.attachEvent('export:onConfigOptionChange', option => {
    if (option.id === 'current_day_marker') {
      option.value ? TodayMarker.addMarker() : TodayMarker.removeMarker();

      return;
    }
    Config.setConfigParameter(option.id, option.value, true);

    if (option.id === 'show_float_time' && option.value) {
      instance.config.columns.find(col => col.name === 'total_float').isShowCheckbox = true;
      instance.config.columns.find(col => col.name === 'free_float').isShowCheckbox = true;

      ColumnsConfig.showColumn('total_float');
      ColumnsConfig.showColumn('free_float');

      ColumnsBar.initGanttColumns(instance.config.columns, ColumnsConfig.config);
      instance.render();
    } else if (option.id === 'show_float_time' && !option.value) {
      instance.config.columns.find(col => col.name === 'total_float').isShowCheckbox = false;
      instance.config.columns.find(col => col.name === 'free_float').isShowCheckbox = false;
      ColumnsConfig.hideColumn('total_float');
      ColumnsConfig.hideColumn('free_float');
      ColumnsBar.initGanttColumns(instance.config.columns, ColumnsConfig.config);
      instance.render();
    }
  });

  instance.attachEvent('export:onColumnVisibilityChange', column => {
    Columns.changeColumnCheckbox(column.isAdvanced ? column.mainColumnId : column.id, column.isVisible, column.isAdvanced);
    const t = log.time('ganttRender.instance');

    instance.render();
    t.end();
  });

  instance.attachEvent('export:onZoomChange', zoomLevel => {
    Zoom.setZoomLevel(zoomLevel);
  });

  instance.attachEvent('export:onBaselineEnable', async baseline => {
    await Baselines.buildBaseline(baseline);
  });

  instance.attachEvent('export:onBaselineDisable', baselineId => {
    Baselines.removeBaseline(baselineId);
  });

  instance.attachEvent('export:onCustomColumnsValuesLoaded', () => {
    const t = log.time('ganttRender.instance');

    instance.render();
    t.end();
  });
};
